import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr } from "../../../Helper/ToastMessage";


export const GardenMainPanelityReportTableDataAPI = createAsyncThunk("GardenMainPanelityReportTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_ZoneID,
        M_WorkTypeID,
        M_ContractorID,
        M_AssetTypeID,
        M_WardData,
        UserID,
        token,
        Flag,
        handleGetPDFUrl,
        setGridData,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_RM_DB_GD_PENALTY_SELECT?FromDate=${FromDate}&ToDate=${ToDate}&M_ZoneID=${M_ZoneID ? M_ZoneID : 0}&M_ContractorID=${M_ContractorID ? M_ContractorID : 0}&M_WorkTypeID=${M_WorkTypeID ? M_WorkTypeID : 0}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : 0}&M_WardData=${M_WardData ? M_WardData : 0}&M_UserID=${UserID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                { Flag == 'PDF_Report' && handleGetPDFUrl(result.url) }
                setGridData && setGridData(result.data)
                return result.data
            } else {
                // toastErrorr(result.message)
                return result
            }
        })
})

const GardenMainPanelityReportTableDataSlice = createSlice({
    name: "GardenMainPanelityReportTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GardenMainPanelityReportTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GardenMainPanelityReportTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(GardenMainPanelityReportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const GardenMainPanelityReportTableDataReducer = GardenMainPanelityReportTableDataSlice.reducer


// Garden Penalty PDF Report

export const GardenMainPanelityPDFReportDataAPI = createAsyncThunk("GardenMainPanelityPDFReportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_ZoneID,
        M_WorkTypeID,
        M_ContractorID,
        M_AssetTypeID,
        M_WardData,
        UserID,
        token,
        Flag,
        handleGetPDFUrl
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_RM_DB_GD_PENALTY_SELECT?FromDate=${FromDate}&ToDate=${ToDate}&M_ZoneID=${M_ZoneID ? M_ZoneID : 0}&M_ContractorID=${M_ContractorID ? M_ContractorID : 0}&M_WorkTypeID=${M_WorkTypeID ? M_WorkTypeID : 0}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : 0}&M_WardData=${M_WardData ? M_WardData : 0}&M_UserID=${UserID}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                { Flag == 'PDF_Report' && handleGetPDFUrl(result.url) }
                return result.data
            } else {
                // toastErrorr(result.message)
                return result
            }
        })
})

const GardenMainPanelityPDFReportDataSlice = createSlice({
    name: "GardenMainPanelityPDFReportData",
    initialState: {
        isPDFReportLoading: false,
        pdftableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GardenMainPanelityPDFReportDataAPI.pending, (state, action) => {
            state.isPDFReportLoading = true;
        });
        builder.addCase(GardenMainPanelityPDFReportDataAPI.fulfilled, (state, action) => {
            state.isPDFReportLoading = false;
            state.pdftableData = action.payload;
        });
        builder.addCase(GardenMainPanelityPDFReportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPDFReportLoading = false;
            state.isError = true;
            state.pdftableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const GardenMainPanelityPDFReportDataReducer = GardenMainPanelityPDFReportDataSlice.reducer